import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Select } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { PaysDto } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';
import { ControlPanelStore } from 'src/states/control-panel.store';

@Component({
  selector: 'app-pays-select',
  templateUrl: './pays-select.component.html',
  styleUrls: ['./pays-select.component.css']
})
export class PaysSelectComponent implements OnInit, OnDestroy {
  @Select(ControlPanelStore.pays$) pays$: Observable<PaysDto[]>;

  @Input('width') width: number;

  @Input() disabled: boolean = false;
  
  @Input() paysId: number;
  @Output() paysIdChange = new EventEmitter<number>();

  @Input() cell: any;

  InitId = null;

  Pays: PaysDto[] = [];

  p: Subscription;

  constructor(private panelLayoutService: PanelLayoutService,
    private translate: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
      // Instanciate Globalize for DevExtreme components
      this.devExtremeTranslationService.loadLanguage(this.translate.getBrowserLang());
    }

  ngOnInit() {
    if(this.paysId != null) {
      this.InitId = JSON.parse(JSON.stringify(this.paysId));
    }
    this.p = this.pays$.subscribe(res => {
      if (res != null) {
        this.Pays = res;
      }
    });
  }

  ngOnDestroy() {
    this.p?.unsubscribe();
  }

  updateInfo(event) {
    if (!!this.cell && this.InitId != this.paysId) {
      this.cell.setValue(this.paysId);
    }
    //this.paysId = event.selectedItem != null ? event.selectedItem.Id : this.paysId;
    this.paysIdChange.emit(this.paysId);
  }

}
